import { FileUp } from "@tamagui/lucide-icons";
import { Button, Headline1, Paragraph2, Sparkles, YStack } from "@medbillai/ui";
import { GrantedLogo } from "../../../components/local-images";
import { UploadDocumentSheet } from "../../../components/upload-document-sheet/UploadDocumentSheet";
import { useScreenLock } from "../../../lib/screen-lock";
import { GET_STARTED_SOURCE, usePushGetHelp } from "../../../lib/usePushGetHelp";
import { useUploadBillFromHome } from "../../../lib/useUploadBillFromHome";
import { useShouldShowUploadBill } from "../utils/useShouldShowUploadBill";
export const WelcomeWidget = () => {
  const {
    pushGetHelp
  } = usePushGetHelp();
  const {
    disableScreenLock,
    enableScreenLock
  } = useScreenLock();
  const shouldShowUploadBill = useShouldShowUploadBill();
  const {
    isUploadSheetOpen,
    isUploading,
    openUploadSheet,
    closeUploadSheet,
    handleFilesLoaded,
    handleUploadError
  } = useUploadBillFromHome();
  return <YStack alignItems="center" $platform-web={{
    mt: "$10"
  }} justifyContent="flex-start" gap="$5" data-sentry-element="YStack" data-sentry-component="WelcomeWidget" data-sentry-source-file="WelcomeWidget.tsx">
      <GrantedLogo height={88} width={88} data-sentry-element="GrantedLogo" data-sentry-source-file="WelcomeWidget.tsx" />

      <YStack alignItems="center" gap="$1" data-sentry-element="YStack" data-sentry-source-file="WelcomeWidget.tsx">
        <Headline1 color="$navy12" data-sentry-element="Headline1" data-sentry-source-file="WelcomeWidget.tsx">Meet Granted</Headline1>
        <Paragraph2 color="$textSecondary" data-sentry-element="Paragraph2" data-sentry-source-file="WelcomeWidget.tsx">
          Your AI healthcare assistant
        </Paragraph2>
      </YStack>

      {shouldShowUploadBill ? <Button size="large" fillWidth={false} onPress={openUploadSheet} loading={isUploading} iconLeft={FileUp}>
          Upload bill
        </Button> : <Button size="large" fillWidth={false} iconRight={Sparkles} onPress={() => pushGetHelp({
      caseType: "OTHER",
      title: "Get started with Granted",
      source: GET_STARTED_SOURCE
    })}>
          Get started
        </Button>}
      <UploadDocumentSheet title="Upload bill for review" open={isUploadSheetOpen} onUploadError={handleUploadError} onOpenChange={closeUploadSheet} onCameraPermissionCheckStart={disableScreenLock} onCameraPermissionCheckComplete={enableScreenLock} onFilesLoaded={handleFilesLoaded} data-sentry-element="UploadDocumentSheet" data-sentry-source-file="WelcomeWidget.tsx" />
    </YStack>;
};